import React, { useState } from 'react';
import './MenuButton.css';

interface MenuButtonProps {
  isMuted: boolean;
  isDarkMode: boolean;
  isInfinityMode: boolean;
  onToggleMute: () => void;
  onToggleDarkMode: () => void;
  onToggleInfinityMode: () => void;
  onShowHowToPlay: () => void;
  onShowAbout: () => void;
  onShowLeaderboard: () => void;
  onShowLevel: () => void;
  onSignOut: () => void;
}

const MenuButton: React.FC<MenuButtonProps> = ({
  isMuted,
  isDarkMode,
  isInfinityMode,
  onToggleMute,
  onToggleDarkMode,
  onToggleInfinityMode,
  onShowHowToPlay,
  onShowAbout,
  onShowLeaderboard,
  onShowLevel,
  onSignOut
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="menu-container">
      <button
        className={`logo-menu-button ${isOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label="Menu"
      >
        <img src="/snap_pairs_tile.png" alt="Menu" className="logo-menu-icon" />
      </button>

      {isOpen && (
        <div className="menu-dropdown">
          <div className="menu-item" onClick={onToggleMute}>
            <span className="menu-icon">{isMuted ? '🔇' : '🔊'}</span>
            <span className="menu-label">{isMuted ? 'Unmute' : 'Mute'}</span>
          </div>

          <div className="menu-item" onClick={onToggleDarkMode}>
            <span className="menu-icon">{isDarkMode ? '🌙' : '🌈'}</span>
            <span className="menu-label">{isDarkMode ? 'Dark Mode' : 'Colorful Mode'}</span>
          </div>

          <div className="menu-item" onClick={onToggleInfinityMode}>
            <span className="menu-icon">∞</span>
            <span className="menu-label">{isInfinityMode ? 'Infinity Mode' : 'Timed Mode'}</span>
          </div>

          <div className="menu-item" onClick={() => { onShowLevel(); setIsOpen(false); }}>
            <span className="menu-icon">🎯</span>
            <span className="menu-label">Level</span>
          </div>

          <div className="menu-item" onClick={() => { onShowLeaderboard(); setIsOpen(false); }}>
            <span className="menu-icon">🏆</span>
            <span className="menu-label">Leaderboard</span>
          </div>

          <div className="menu-item" onClick={() => { onShowHowToPlay(); setIsOpen(false); }}>
            <span className="menu-icon">❓</span>
            <span className="menu-label">How to Play</span>
          </div>

          <div className="menu-item" onClick={() => { onShowAbout(); setIsOpen(false); }}>
            <span className="menu-icon">ℹ️</span>
            <span className="menu-label">About</span>
          </div>

          <div className="menu-item" onClick={() => { onSignOut(); setIsOpen(false); }}>
            <span className="menu-icon">🚪</span>
            <span className="menu-label">Sign Out</span>
          </div>
        </div>
      )}

      {isOpen && (
        <div className="menu-backdrop" onClick={toggleMenu}></div>
      )}
    </div>
  );
};

export default MenuButton;
